<template>
    <v-container fluid>
        <v-row>
            <sarala-table
                :model="model"
                :createRoute="{ name: 'category.create' }"
                :resourceName="$tc('resources.category.name', 1)"
                ref="table"
            >
                <template #percent="{ item }">
                    {{ $n(item.percent / 100, 'percent') }}
                </template>

                <template #discount_percentage="{ item }">
                    {{ $n(item.discount_percentage / 100, 'percent') }}
                </template>

                <template #reseller_types="{ item }">
                    <v-chip
                        v-for="reseller_type in item.resellerTypes"
                        :key="reseller_type.id"
                        :color="reseller_type.color"
                        :text-color="reseller_type.text_color"
                        class="mr-1"
                    >
                        {{ reseller_type.name }}
                    </v-chip>
                </template>

                <template #action="{ item }">
                    <edit-btn
                        :to="{
                            name: 'category.edit',
                            params: { id: item.id },
                        }"
                    />

                    <delete-btn @click="deleteItem(item)" />
                </template>
            </sarala-table>
        </v-row>
        <confirm-delete ref="confirmDelete" />
    </v-container>
</template>

<script>
import Category from '@/models/Category'
import SaralaTable from '@/shared/components/SaralaTable'
export default {
    components: {
        SaralaTable,
    },

    computed: {
        model() {
            return new Category()
        },
    },

    methods: {
        async deleteItem(item) {
            let confirmed = await this.$refs.confirmDelete.confirm(item.name)
            if (!confirmed) return

            await item.delete()

            this.$refs.table.getItems()

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.delete', {
                    resource: this.$tc('resources.category.name'),
                }),
            )
        },
    },
}
</script>

<style></style>
